(function () {
  'use strict';

  var IMS_API_URL = 'https://ims.refurbished.it/prodj.php?sku=';
  var currentImsSku = null;

  // Saved original slide HTML arrays per gallery (keyed by index in galleries list)
  // Each entry: { mainSlides: [htmlString, ...], navSlides: [htmlString, ...], hadLoop: bool }
  var originalSlidesMap = new Map();

  function getSelectedSku() {
    var variantInput = document.querySelector('#product-form-installment input[name="id"]');
    if (!variantInput) return null;

    var selectedVariantId = variantInput.value;
    var variantsEl = document.getElementById('productVariants');
    if (!variantsEl) return null;

    var variants = JSON.parse(variantsEl.textContent);
    var sku = null;
    variants.forEach(function (v) {
      if (String(v.id) === String(selectedVariantId)) {
        sku = v.sku;
      }
    });
    return sku;
  }

  function getMediaGalleries() {
    var galleries = [];
    var desktop = document.querySelector('.m-product-media--desktop media-gallery');
    if (desktop) galleries.push(desktop);
    var mobile = document.querySelector('.m-product-media--mobile media-gallery');
    if (mobile) galleries.push(mobile);
    if (galleries.length === 0) {
      var any = document.querySelector('media-gallery');
      if (any) galleries.push(any);
    }
    return galleries;
  }

  function mainSlideHTML(imageUrl, index) {
    return '<div class="swiper-slide m-product-media--item media-type-image" ' +
      'data-index="' + index + '" data-media-type="image" ' +
      'data-media-id="ims-' + index + '" data-aspect-ratio="1" data-ims-slide="true">' +
        '<div class="m-product-media" data-media-id="ims-' + index + '" ' +
          'data-media-width="1000" data-media-height="1000" ' +
          'data-media-alt="Poza reala produs" data-media-src="' + imageUrl + '">' +
          '<responsive-image class="m-image" style="--aspect-ratio: 1">' +
            '<img src="' + imageUrl + '" width="1000" height="1000" ' +
              'alt="Poza reala produs" loading="lazy" ' +
              'style="width:100%;height:auto;object-fit:contain;">' +
          '</responsive-image>' +
        '</div>' +
      '</div>';
  }

  function thumbSlideHTML(imageUrl, index) {
    return '<div class="swiper-slide media-type-image" ' +
      'data-index="' + index + '" data-ims-slide="true">' +
        '<div class="m-product-media" data-media-id="ims-' + index + '">' +
          '<responsive-image class="m-image" style="--aspect-ratio: 1">' +
            '<img src="' + imageUrl + '" loading="lazy" width="110" height="110" ' +
              'alt="Poza reala produs">' +
          '</responsive-image>' +
        '</div>' +
      '</div>';
  }

  // Save original slides HTML before any modification (called once per gallery)
  function saveOriginalSlides(gallery) {
    if (originalSlidesMap.has(gallery)) return; // already saved

    var mainSlider = gallery.slider;
    var navSlider = gallery.navSlider;
    var saved = { mainSlides: [], navSlides: [], hadLoop: false };

    if (mainSlider) {
      saved.hadLoop = mainSlider.params.loop;
      // Destroy loop to get clean slides without duplicates
      if (saved.hadLoop) {
        mainSlider.loopDestroy();
      }
      // Save outerHTML of each real slide
      Array.from(mainSlider.slides).forEach(function (slide) {
        saved.mainSlides.push(slide.outerHTML);
      });
      // Re-enable loop
      if (saved.hadLoop) {
        mainSlider.loopCreate();
        mainSlider.update();
      }
    }

    if (navSlider) {
      Array.from(navSlider.slides).forEach(function (slide) {
        saved.navSlides.push(slide.outerHTML);
      });
    }

    originalSlidesMap.set(gallery, saved);
  }

  // Restore original slides (before re-applying IMS changes for a new variant)
  function restoreOriginalSlides(gallery) {
    var saved = originalSlidesMap.get(gallery);
    if (!saved) return;

    var mainSlider = gallery.slider;
    var navSlider = gallery.navSlider;

    if (mainSlider) {
      // Destroy loop first
      if (mainSlider.params.loop) {
        mainSlider.loopDestroy();
      }
      // Remove ALL current slides
      var total = mainSlider.slides.length;
      var indices = [];
      for (var i = 0; i < total; i++) indices.push(i);
      if (indices.length > 0) mainSlider.removeSlide(indices);

      // Re-add original slides
      mainSlider.appendSlide(saved.mainSlides);

      // Re-enable loop
      if (saved.hadLoop) {
        mainSlider.params.loop = true;
        mainSlider.loopCreate();
      }
      mainSlider.update();
      if (saved.hadLoop) {
        mainSlider.slideToLoop(0, 0, false);
      } else {
        mainSlider.slideTo(0, 0, false);
      }
    }

    if (navSlider) {
      var navTotal = navSlider.slides.length;
      var navIndices = [];
      for (var j = 0; j < navTotal; j++) navIndices.push(j);
      if (navIndices.length > 0) navSlider.removeSlide(navIndices);

      navSlider.appendSlide(saved.navSlides);
      navSlider.update();
    }
  }

  // Keep only first slide, then append IMS slides
  function applyImsSlides(gallery, images) {
    var mainSlider = gallery.slider;
    var navSlider = gallery.navSlider;

    if (mainSlider) {
      // Destroy loop for clean indices
      var hadLoop = mainSlider.params.loop;
      if (hadLoop) {
        mainSlider.loopDestroy();
      }

      // Remove all slides except index 0
      var total = mainSlider.slides.length;
      var indicesToRemove = [];
      for (var i = 1; i < total; i++) indicesToRemove.push(i);
      if (indicesToRemove.length > 0) mainSlider.removeSlide(indicesToRemove);

      // Append IMS slides
      var mainSlidesHTML = [];
      images.forEach(function (imgUrl, idx) {
        mainSlidesHTML.push(mainSlideHTML(imgUrl, idx + 1));
      });
      mainSlider.appendSlide(mainSlidesHTML);

      // Re-enable loop
      if (hadLoop) {
        mainSlider.params.loop = true;
        mainSlider.loopCreate();
      }
      mainSlider.update();
      if (hadLoop) {
        mainSlider.slideToLoop(0, 0, false);
      } else {
        mainSlider.slideTo(0, 0, false);
      }
    }

    if (navSlider) {
      // Remove all nav slides except index 0
      var navTotal = navSlider.slides.length;
      var navIndicesToRemove = [];
      for (var j = 1; j < navTotal; j++) navIndicesToRemove.push(j);
      if (navIndicesToRemove.length > 0) navSlider.removeSlide(navIndicesToRemove);

      // Append IMS thumb slides
      var thumbSlidesHTML = [];
      images.forEach(function (imgUrl, idx) {
        thumbSlidesHTML.push(thumbSlideHTML(imgUrl, idx + 1));
      });
      navSlider.appendSlide(thumbSlidesHTML);
      navSlider.update();
    }
  }

  // Rebuild PhotoSwipe lightbox data source
  function rebuildPhotoswipe(gallery) {
    if (!gallery.lightbox) return;

    var items = [];
    var slides = gallery.querySelectorAll('.m-product-media--item:not(.swiper-slide-duplicate)');
    slides.forEach(function (slide) {
      if (slide.dataset.mediaType === 'image') {
        var mediaDiv = slide.querySelector('.m-product-media');
        if (mediaDiv) {
          items.push({
            src: mediaDiv.dataset.mediaSrc,
            width: parseInt(mediaDiv.dataset.mediaWidth) || 1000,
            height: parseInt(mediaDiv.dataset.mediaHeight) || 1000,
            alt: mediaDiv.dataset.mediaAlt || '',
            id: slide.dataset.index
          });
        }
      } else {
        items.push({
          html: '<div class="pswp__' + slide.dataset.mediaType + '">' + slide.innerHTML + '</div>',
          type: slide.dataset.mediaType,
          id: slide.dataset.index
        });
      }
    });

    gallery.lightbox.options.dataSource = items;
  }

  function injectImages(images) {
    var galleries = getMediaGalleries();
    galleries.forEach(function (gallery) {
      // 1. Save original slides (only on first call)
      saveOriginalSlides(gallery);

      // 2. Restore originals (needed on variant change to get clean state)
      restoreOriginalSlides(gallery);

      // 3. Keep first slide + append IMS images
      applyImsSlides(gallery, images);

      // 4. Rebuild PhotoSwipe
      rebuildPhotoswipe(gallery);
    });
  }

  function fetchAndInject() {
    var sku = getSelectedSku();
    if (!sku) return;

    if (sku === currentImsSku) return;
    currentImsSku = sku;

    fetch(IMS_API_URL + encodeURIComponent(sku))
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data.success) return;

        var images = [];
        if (data.image1) images.push(data.image1);
        if (data.image2) images.push(data.image2);

        if (images.length > 0) {
          injectImages(images);
        }
      })
      .catch(function (err) {
        console.warn('IMS images: could not fetch external images', err);
      });
  }

  function init() {
    // Wait for Swiper to fully initialize
    setTimeout(fetchAndInject, 1500);

    // Listen for variant changes
    var variantInput = document.querySelector('#product-form-installment input[name="id"]');
    if (variantInput) {
      var observer = new MutationObserver(function () {
        currentImsSku = null;
        setTimeout(fetchAndInject, 500);
      });
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }

    var form = document.getElementById('product-form-installment');
    if (form) {
      form.addEventListener('change', function () {
        currentImsSku = null;
        setTimeout(fetchAndInject, 500);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
